import { permissions } from '@/constants';
import { ComponentTierName } from '@/constants/enums';
import { StationControlType } from '@/store/Lifecycle/constants';
import PermissionStore from '@/store/PermissionStore';
import StationStore from '@/store/Station/StationStore';
import { getStationStageColors, token } from '@/theme';
import { checkTierPermission } from '@/utils/util-functions';
import isEmpty from 'lodash/isEmpty';

// Current Status to be available for the user to see
// and user has the permission to view the station stage
// and user has the permission to update the station stage
export const canShowCurrentStageCard = (
  permissionStore: PermissionStore,
  stationStore: StationStore,
  currentStatus,
) => {
  return (
    permissionStore.isAuth(permissions.UPDATE_STATION_STAGE) ||
    permissionStore.isAuth(permissions.VIEW_STATION_STAGE) ||
    (!checkTierPermission(ComponentTierName.ProactiveEngine, stationStore) && !isEmpty(currentStatus?.name))
  );
};

export const canShowStationStage = (permissionStore: PermissionStore): boolean => {
  return (
    permissionStore.isAuth(permissions.UPDATE_STATION_STAGE) || permissionStore.isAuth(permissions.VIEW_STATION_STAGE)
  );
};

export const canShowStationStatus = (stationStore: StationStore, currentStatus): boolean => {
  return !checkTierPermission(ComponentTierName.ProactiveEngine, stationStore) && !isEmpty(currentStatus?.name);
};

export const getColorByStageOrder = (order: number) => {
  const stageColors = getStationStageColors(token);
  return stageColors[(order - 1) % (stageColors.length + 1)];
};

export const getColorByStatusOrder = (order: number) => {
  return order === 1 ? 'error' : [2, 3, 6].includes(order) ? 'success' : 'warning';
};

export const getStatusColorAndText = (
  controlType: StationControlType,
  currentStatus: { id: number; name: string; order: number },
) => {
  return controlType === StationControlType.NotControlled
    ? { color: 'default', text: 'Not Controlled' }
    : { color: getColorByStatusOrder(currentStatus?.order), text: 'StationStatus_' + currentStatus?.name };
};
